import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import Cookies from "js-cookie";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import DatePicker from "react-date-picker";
import moment from "moment";
import { NavLink, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const MaterialChart = ({
  companyId,
  user_id,
  selectedDate,
  companyName,
  companyLocation,
  companyType,
}) => {
  const [chartKey, setChartKey] = useState(0);
  const [graphChartKey, setGraphChartKey] = useState(0);
  const token = Cookies.get("token")?.replace(/"/g, "");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [chartType, setChartType] = useState("pie");
  const [chartsData, setChartsData] = useState([]);
  const [productId, setProductId] = useState("");
  // console.log("productId", productId)
  const [product, setProduct] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const fixedOrder = ["OIL", "HT WIRE", "GI WIRE", "CEMENT", "SAND", "BT METAL", "COLOUR"];

  const navigate = useNavigate();

  // const getProduct = async () => {
  //   let BASE_URL = SERVER_URL + `/api/product/drop-products/${user_id}`;
  //   const res = await fetch(BASE_URL, {
  //     method: "POST",
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       company_id: companyId
  //     })
  //   });
  //   const result = await res.json();
  //   if (res.ok) {
  //     const combinedComp = result.data
  //       ?.sort((a, b) => a.id - b.id)
  //       ?.map((data) => ({
  //         productName: data.product_name,
  //         size: data.size,
  //         id: data.id,
  //       }));
  //     setProduct(combinedComp);
  //   } else {
  //     setProduct([])
  //   }
  // };

  // useEffect(() => {
  //   getProduct();
  // }, []);
  // useEffect(() => {
  //   if (product?.length > 0) {
  //     setSelectedProduct(product[0]);
  //     setProductId(product[0]?.id);
  //   }
  // }, [product]);

  const handleProductChange = (e) => {
    const parseCompany = JSON.parse(e.target.value);
    const { productName, size, id } = parseCompany;
    setSelectedProduct({ productName, size, id });
    setProductId(id);
    // const selectedCompany = company.find(
    //   (item) =>
    //     item.company_name === e.target.value.split(",")[0] &&
    //     item.location === e.target.value.split(",")[1]
    // );

    // if (selectedCompany) {
    //   // setLocation(selectedCompany.location || "");
    //   setCompanyId(selectedCompany.id || "");
    //   // setSelectedCompany(selectedCompany);
    // }
  };

  useEffect(() => {
    AOS.init();
  }, []);

  const materialColorMap = {
    "HT WIRE": "#3ABBC9",
    CEMENT: "#65d97d",
    "GI WIRE": "#661E59",
    "BT METAL": "#d9cd65",
    SAND: "#09F8B8",
    "BLACK OIL": "#2C08DF",
    COLOUR: "#F1A207",
  };
  const generateColors = (labels) => {
    return labels?.map(
      (label) => materialColorMap[label] || "#65B963",
      "#2BCBE0",
      "#40BFFF",
      "#58B7FF",
      "#9D76C3",
      "#BE8EE4"
    );
  };
  const [chartState, setChartState] = useState({
    series: [],
    options: {
      chart: {
        type: "pie",
      },
      labels: [],
      xaxis: {
        categories: [],
      },
    },
  });
  const getData = async () => {
    const renewalDate = moment(selectedDate).format("DD-MM-YYYY");
    try {
      const BASE_URL = `${SERVER_URL}/api/raw-mat/raw-material-details-chart/${user_id}?date=${renewalDate}&company_id=${companyId}`;
      const res = await fetch(BASE_URL, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const result = await res.json();

      const dataMap = result.data.reduce((acc, item) => {
        acc[item.rawMaterialName.material_name] = item.closing_stock;
        return acc;
      }, {});

      const materialNames = fixedOrder;
      const closingStocks = fixedOrder.map((name) => dataMap[name] || 0);
      const colors = generateColors(materialNames);
      setChartState({
        options: {
          ...chartState.options,
          labels: materialNames,
          xaxis: {
            categories: materialNames,
          },
          colors: colors,
          plotOptions: {
            bar: {
              distributed: true,
            },
          },
        },
        series:
          chartType === "pie" || chartType === "donut"
            ? closingStocks
            : [
                {
                  name: "Closing Stock",
                  data: closingStocks,
                },
              ],
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const updateChartType = (type) => {
    setChartType(type);
    setChartKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    getData();
  }, [companyId, selectedDate, chartType]);
  return (
    <>
      <div
        className="col-xl-6 col-lg-12 grid-margin"
        // data-aos="fade-up"
        // data-aos-duration="1000"
        // data-aos-offset="50"
      >
        <div>
          <div className="card">
            <div className="card-body">
              <div className="d-flex chart-content">
                <div>
                  <p className="card-title">Raw Material Stock Report</p>
                </div>
                <div className=" dropdown-charts d-flex">
                  {/* <select
                    value={JSON.stringify(selectedProduct)}
                    onChange={handleProductChange}
                    className="form-control mr-1"
                    style={{ width: "auto" }}
                  >
                    {product?.map((data, index) => {
                      return (
                        <option
                          value={JSON.stringify({
                            productName: data.product_name,
                            size: data.size,
                            id: data.id,
                          })}
                          key={index}
                        >
                          {data.productName} - {data.size}
                        </option>
                      );
                    })}
                  </select> */}
                  <select
                    value={chartType}
                    onChange={(e) => updateChartType(e.target.value)}
                    className="form-control"
                    style={{ width: "auto" }}
                  >
                    <option value="pie">Pie</option>
                    <option value="donut">Donut</option>
                    <option value="bar">Bar</option>
                  </select>
                  <button
                    type="button"
                    onClick={() =>
                      navigate(
                        "/raw-material-details" + `?companyId=${companyId}`
                      )
                    }
                    className="btn btn-sm btn-light btn-icon-text ml-1"
                  >
                    {" "}
                    Detail<span className="mdi mdi-arrow-right"></span>
                  </button>
                </div>
              </div>
              <div>
                <h4>{`${companyName}, ${companyLocation}`}</h4>
              </div>
              <div className="chart-container">
                <Chart
                  key={chartKey}
                  options={{
                    ...chartState.options,
                    chart: {
                      type: chartType,
                    },
                    colors: generateColors(chartState?.options?.labels),
                    legend: {
                      markers: {
                        fillColors: generateColors(chartState.options.labels),
                      },
                    },
                  }}
                  series={chartState.series}
                  type={chartType}
                  width="90%"
                  height="250px"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="col-md-6 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <div className="d-flex chart-content">
              <div>
                <p className="card-title">Raw Material Stock Report</p>
              </div>
              <div className="d-flex">
                <select
                  value={graphType}
                  onChange={(e) => updateGraphType(e.target.value)}
                  className="form-control"
                  style={{ width: "auto" }}
                >
                  <option value="area">Area</option>
                  <option value="line">Line</option>
                  <option value="bar">Bar</option>
                </select>
                <button
                  type="button"
                  onClick={() => navigate("/raw-material-details")}
                  className="btn btn-sm btn-light btn-icon-text ml-1"
                >
                  {" "}
                  Detail<span className="mdi mdi-arrow-right"></span>
                </button>
              </div>
            </div>
            <div className="chart-container">
              <Chart
                key={graphChartKey}
                options={graphState.options}
                series={graphState.series}
                type={graphType}
                width="90%"
                height="250px"
              />
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default MaterialChart;
